<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6YD9w1/image/front.jpg?1718732567974" alt="This image is the cover for the book The Singing Trolls"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Singing Trolls
      </h1>
      <p class="bookDescription body article font2">
        <p>This interactive book aims to encourage children’s imagination and interpretation through thoughtful questions and drawing prompts. Designed to be read aloud, it will stimulate parent-child bonding and build fond memories. Studies show reading aloud cultivates future readers. The story explores the wonders of nature and the interconnections between animals, insects, and plants. It sparks a mindfulness of the natural world and a curiosity to explore outdoors. Through imaginative play with natural materials, children gain a deeper appreciation of nature’s gifts. This sharing of ideas strengthens not only language skills but also emotional intelligence. So curl up together and dive into the magic of nature through the pages of this keepsake book. Furthermore, the book hopes to spread joy. As children create their own continuations of the story, their imagination sparks even more delight. Few things are more wonderful than hearing a child’s laughter and seeing the joy in their eyes. Reading aloud facilitates quality time and deepens the mutual bonds between child and caregiver. This book aims to create space for such magical shared moments.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellis Janzon
      </h2>
      
      <p class="authorDescription body article">Ellis Janzon is a retired Assistant Professor and academic teacher in public health who now lives near the sea and forest. Nature inspired the writing of this book. It aims to develop young children’s understandings about the joy of being in nature and inspiring them by what it has to offer. It also aims to teach children about healthy eating and showing kindness to all animals. Most of all, this book hopes to spread joy, and that by reading to their child, the reader and child build joyful memories together.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?463f52ca